import CloseIcon from "@mui/icons-material/Close";
import { Box, CircularProgress, IconButton } from "@mui/material";
import { memo, useCallback, useContext, useEffect, useRef, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { UserContext } from "../../../../../../App";
import {
  fetchLoyality,
  getLoyaltyCorrespondingValue,
  redeemLoyalty,
  redeemLoyaltyOtp,
  removeLoyalty,
  validateLoyaltyOtp,
} from "../../../../../../config/Services";
import { eventTrackerConstant } from "../../../../../common/event-tracker/event-tracker-constants";
import { eventTracker } from "../../../../../common/event-tracker/eventTracker";
import { BootstrapInput } from "../../../../posnavbar/components/addCustomer/components/bootStrapInput";
import { useSnackbar } from "../../../hooks/SnackbarProvider";
import useFetch from "../../../hooks/useFetch";
import useGetDevice from "../../../hooks/useGetDevice";
import { getCouponState } from "../../redux/Reducers/couponReducer";
import StyledButton from "../custom/StyledButton";
import "./index.css";
import { customEventTrigger } from "../../../../../../analytics";
import { getStoreCurrencySymbol } from "../../../../../../utils/currency";

const LoyaltySectionModal = ({
  setLoyaltyModal,
  setOpen,
  setOpenCartCustomerDetail,
  type = "GROCERY",
  setShowLoyalty,
}) => {
  const isMobile = useGetDevice();
  const showSnackbar = useSnackbar();
  const { total, cartItems, setTotal, loyaltyPoints, setLoyaltyPoints, couponApplied } =
    useContext(UserContext);
  const orgId = localStorage.getItem("orgId");
  const cartId = localStorage.getItem("CartId");
  const [loyaltyData, setLoyaltyData] = useState(null);
  let customerUidx = JSON.parse(localStorage.getItem("customer_details"))?.uidx;
  const couponState = useSelector(getCouponState, shallowEqual);
  const [removeTextIcon, setRemoveTextIcon] = useState(false);
  const [redeemLoader, setRedeemLoader] = useState(false);
  const [noDataFound, setNoDataFound] = useState(false);
  const customerMobile = JSON.parse(localStorage.getItem("customer_details"))?.mobileNumber;
  const AddCusRef = useRef(null);
  const [otpVal, setOtpVal] = useState("");
  const lPoints = localStorage.getItem("loyaltyPoints");
  const retailType = localStorage.getItem("retailType");
  const closeLoyaltyModal = useCallback(() => setLoyaltyModal(false), []);
  const [otpReq, setOtpReq] = useState("");
  const [blacklisted, setBlacklisted] = useState({
    label: "",
    stat: false,
  });
  const [inputs, setInputs] = useState({ value: "", points: "" });
  const [loyaltyPayloadValue, setLoyaltyPayloadValue] = useState(null);
  const [isCheckingCustomer, setIsCheckingCustomer] = useState(true);

  useEffect(() => {
    const checkCustomer = async () => {
      const prevUidx = localStorage.getItem("loyalty_prev_uidx");
      if (prevUidx !== null && prevUidx !== customerUidx) {
        const appliedPoints = localStorage.getItem("loyaltyPoints");

        // Clear local states
        localStorage.removeItem("loyaltyPoints");
        if (setLoyaltyPoints) setLoyaltyPoints("");
        if (setShowLoyalty) setShowLoyalty(false);
        
        setLoyaltyData(null);
        setLoyaltyPayloadValue(null);
        setInputs({ value: "", points: "" });

        if ((appliedPoints || couponApplied) && cartId) {
          try {
            setRedeemLoader(true);
            const res = await removeLoyalty(cartId);
            if (res?.data?.data?.billing?.totalCartValue) {
              setTotal(res.data.data.billing.totalCartValue);
            }
          } catch (e) {
            showSnackbar(e?.response?.data?.message || "Error removing loyalty", "error");
          } finally {
            setRedeemLoader(false);
          }
        }
      }
      localStorage.setItem("loyalty_prev_uidx", customerUidx || "");
      setIsCheckingCustomer(false);
    };
    checkCustomer();
  }, [customerUidx, cartId]);

  const fetchRedeemPoints = useFetch({
    name: "fetch-loyality",
    service: fetchLoyality,
    params: {
      sourceOrgId: orgId,
      cartValue: total,
      customerType: "end_customer",
      customerId: customerUidx,
      // couponApplied: !!couponState ? true : false,
      couponApplied: Boolean(
        couponState &&
          couponState !== "0" &&
          couponState !== 0 &&
          (typeof couponState !== "object" || Object.keys(couponState).length > 0)
      ),
    },
    onSuccess: (res) => {
      if (res?.data?.data) {
        setLoyaltyData(res?.data?.data);
        setLoyaltyPayloadValue(res?.data?.data);
        if (res?.data?.data?.otpValidation) {
          setOtpReq(true);
        } else {
          setOtpReq(false);
        }
        showSnackbar(res?.data?.message || "Success", "success");
      } else {
        setBlacklisted({
          stat: true,
          label: res?.data?.message,
        });
        showSnackbar(res?.data?.message || "Something went wrong while fetching loyalty", "error");
      }
    },
    conditionalRefetch: [couponState, cartItems, total, customerUidx],
    condition: !!customerUidx && !isCheckingCustomer,
  });

  const handleremoveloyality = () => {
    if (!cartId) {
      showSnackbar("Cart is not available to remove loyalty points", "error");
      return;
    }

    setRedeemLoader(true);
    removeLoyalty(cartId)
      .then((res) => {
        if (res?.data?.status === "error" || res?.data?.data?.es > 0) {
          return showSnackbar(
            res?.data?.message || res?.data?.data?.message || "Something went wrong",
            "error"
          );
        }
        showSnackbar(
          "Loyalty points removed successfully, Please apply again to redeem",
          "success"
        );
        localStorage.removeItem("loyaltyPoints");
        if (setShowLoyalty) setShowLoyalty(false);
        setTotal(res?.data?.data?.billing?.totalCartValue);
        setLoyaltyPoints(res?.data?.data?.loyaltyPointsValue);
        setRedeemLoader(false);
        setRemoveTextIcon(false);
        setLoyaltyModal(false);
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message, "error");
        setRedeemLoader(false);
        setRemoveTextIcon(false);
      });
  };

  const handleApplyloyality = () => {
    setRedeemLoader(true);
    const redeemPayload = {
      mobile: customerMobile,
      otp: otpVal,
    };
    validateLoyaltyOtp(redeemPayload)
      .then(() => {
        let payload = {
          currencyCode: loyaltyData?.currencyCode,
          redeemablePoint: loyaltyPayloadValue?.redeemablePoint,
          redeemablePointValue: loyaltyPayloadValue?.redeemablePointValue,
          totalAvailablePoint: loyaltyPayloadValue?.totalAvailablePoint,
          availablePointValue: loyaltyPayloadValue?.availablePointValue,
          customRedeemablePoints: Number(inputs?.points),
          customRedeemableValue: Number(inputs?.value),
        };
        customEventTrigger("pos_redeem_btn", {
          total_point: payload.totalAvailablePoint,
          redeem_point: payload.redeemablePoint,
        });
        redeemLoyalty(payload, cartId)
          .then((res) => {
            setTotal(res?.data?.data?.billing?.totalCartValue);
            setLoyaltyPoints(res?.data?.data?.loyaltyPointsValue);
            localStorage.setItem("loyaltyPoints", res?.data?.data?.loyaltyPointsValue);
            if (setShowLoyalty) setShowLoyalty(true);
            const metaData = {
              cartId: cartId,
              loyaltyPoints: res?.data?.data?.loyaltyPointsValue,
              phoneNumber: customerMobile,
              amount: res?.data?.data?.billing?.totalCartValue,
            };
            eventTracker({ metaData, eventType: eventTrackerConstant.LOYALTY_AWARDED });
            showSnackbar("Loyalty points applied successfully", "success");
            if (type === "RESTAURANT") {
              fetchRedeemPoints.refetch();
            }
            setRemoveTextIcon(true);
            setLoyaltyModal(false);
          })
          .catch((err) => {
            showSnackbar(
              err?.message ||
                err?.response?.data?.message ||
                err?.data?.message ||
                err?.data?.data?.message ||
                "Could not reedem loyalty",
              "error"
            );
            setRemoveTextIcon(false);
          });
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err.message || "Invalid OTP", "error");
      })
      .finally(() => {
        setRedeemLoader(false);
      });
  };

  // useEffect(() => {
  //   if (!otp) return;
  //   const handleKeyPress = (e) => {
  //     if (e.key === "Enter") {
  //       if (loyaltyData) handleApplyloyality();
  //       e.preventDefault();
  //     }
  //     if (e.key === "Delete") {
  //       if (loyaltyData) handleremoveloyality();
  //       e.preventDefault();
  //     }
  //   };
  //   document.addEventListener("keydown", handleKeyPress);
  //   return () => {
  //     document.removeEventListener("keydown", handleKeyPress);
  //   };
  // }, [loyaltyData]);

  useEffect(() => {
    if (!customerMobile) {
      setNoDataFound(true);
    } else {
      setNoDataFound(false);
    }
  }, []);

  const handleLoyaltyCustomer = () => {
    customEventTrigger("add_customer_for_loyalty");
    setOpen(true);
    closeLoyaltyModal();
    setOpenCartCustomerDetail(true);
  };

  const [otp, setOtp] = useState(false);

  const handleGetOtp = () => {
    if (
      inputs.value > loyaltyData?.redeemablePointValue ||
      inputs.points > loyaltyData?.redeemablePointValue
    ) {
      showSnackbar(
        `You can't redeem more than the points available for this cart. You can redeem a maximum of ${getStoreCurrencySymbol()}${loyaltyData?.redeemablePointValue}`,
        "error"
      );
      return;
    }
    if (loyaltyData?.redeemable) {
      const payload = {
        mobile: customerMobile,
      };
      // customEventTrigger("pos_redeem_btn", {
      //   total_point: payload.totalAvailablePoint,
      //   redeem_point: payload.redeemablePoint,
      // });
      redeemLoyaltyOtp(payload).then(() => {
        setOtp(true);
      });
    } else {
      showSnackbar("You don't have any available loyalty points to redeem", "error");
    }
  };

  useEffect(() => {
    // customerMobile?
    AddCusRef?.current?.focus();
  }, []);

  const handleDirectRedeem = () => {
    if (inputs?.value > loyaltyData?.redeemablePointValue) {
      showSnackbar(
        `You can't redeem more than the points available for this cart. You can redeem a maximum of ${getStoreCurrencySymbol()}${loyaltyData?.redeemablePointValue}`,
        "error"
      );
      return;
    }
    let payload = {
      currencyCode: loyaltyData?.currencyCode,
      redeemablePoint: loyaltyPayloadValue?.redeemablePoint,
      redeemablePointValue: loyaltyPayloadValue?.redeemablePointValue,
      totalAvailablePoint: loyaltyPayloadValue?.totalAvailablePoint,
      availablePointValue: loyaltyPayloadValue?.availablePointValue,
      customRedeemablePoints: Number(inputs?.points),
      customRedeemableValue: Number(inputs?.value),
    };
    setRedeemLoader(true);
    redeemLoyalty(payload, cartId)
      .then((res) => {
        setTotal(res?.data?.data?.billing?.totalCartValue);
        setLoyaltyPoints(res?.data?.data?.loyaltyPointsValue);
        localStorage.setItem("loyaltyPoints", res?.data?.data?.loyaltyPointsValue);
        if (setShowLoyalty) setShowLoyalty(true);
        const metaData = {
          cartId: cartId,
          loyaltyPoints: inputs?.points,
          phoneNumber: customerMobile,
          amount: res?.data?.data?.billing?.totalCartValue,
        };
        eventTracker({ metaData, eventType: eventTrackerConstant.LOYALTY_AWARDED });
        showSnackbar("Loyalty points applied successfully", "success");
        if (type === "RESTAURANT") {
          fetchRedeemPoints.refetch();
        }
        setRedeemLoader(false);
        setRemoveTextIcon(true);
        setLoyaltyModal(false);
      })
      .catch((err) => {
        showSnackbar(
          err?.message ||
            err?.response?.data?.message ||
            err?.data?.message ||
            err?.data?.data?.message ||
            "Could not reedem loyalty",
          "error"
        );
        setRemoveTextIcon(false);
      });
  };

  useEffect(() => {
    if (loyaltyData) {
      setInputs({
        value: loyaltyData?.redeemablePointValue || "",
        points: loyaltyData?.redeemablePoint || "",
      });
    }
  }, [loyaltyData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputs((prevInputs) => ({
      ...prevInputs,
      [name]: value,
    }));

    const loyalty = value;
    const type = name;

    const payload = {
      sourceOrgId: orgId,
      cartValue: total,
      customerType: "end_customer",
      customerId: customerUidx,
      couponApplied: couponApplied === "0" ? false : true,
      customRedeemablePoints: type === "points" ? loyalty : null,
      customRedeemableValue: type === "value" ? loyalty : null,
    };
    getLoyaltyCorrespondingValue(payload).then((res) => {
      setLoyaltyPayloadValue(res?.data?.data?.data);
      if (type === "points") {
        setInputs((prevInputs) => ({
          ...prevInputs,
          value: res?.data?.data?.data?.redeemablePointValue || "",
        }));
      } else if (type === "value") {
        setInputs((prevInputs) => ({
          ...prevInputs,
          points: res?.data?.data?.data?.redeemablePoint || "",
        }));
      }
    });
  };

  return (
    <Box>
      {customerMobile ? (
        <div className="show-loyaty-wrapper-info">
          {retailType !== "RESTAURANT" && (
            <>
              <div className="circle-bg-image-9"></div>
              <div className="circle-bg-image-10"></div>
            </>
          )}
          <div className="loyalty-content-container">
            <IconButton className="close-loyalty-modal" onClick={closeLoyaltyModal}>
              <CloseIcon />
            </IconButton>
            {otp ? (
              <div>
                <h4 className="loyalty-text-main-header">
                  OTP sent successfully to your mobile Number{" "}
                  <b className="colored-text">{customerMobile}</b>{" "}
                </h4>

                <label className="enter-otp-loyalty">Enter Otp</label>
                <input
                  type="number"
                  className="otp-validation-input"
                  autoFocus={otp ? true : false}
                  onChange={(e) => setOtpVal(e.target.value)}
                />

                <div className="reset-otp-wrapper">
                  <button className="reset-otp-btn" onClick={handleGetOtp} tabIndex="-1">
                    Resend otp
                  </button>
                </div>
              </div>
            ) : (
              <div>
                {fetchRedeemPoints?.isLoading ? (
                  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <CircularProgress />
                  </Box>
                ) : (
                  <>
                    <h4 className="loyalty-text-main-header">
                      Loyalty Points for the number <b className="colored-text">{customerMobile}</b>{" "}
                    </h4>
                    {blacklisted?.stat ? (
                      <>
                        <h4 className="loyalty-text-blacklist">{blacklisted?.label}</h4>
                      </>
                    ) : (
                      <>
                        <div className="available-wrapper-box-I">
                          <h5 className="points-text-loyalty">Total Points earned</h5>
                          <div className="loyal-wrapper-text-left">
                            {loyaltyData === null ? (
                              <p className="loyalty-small-wrapper-txt">0</p>
                            ) : (
                              <p className="loyalty-small-wrapper-txt">
                                {loyaltyData?.totalAvailablePoint}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="available-wrapper-box">
                          <h5 className="points-text-loyalty">Total Points Value</h5>
                          {loyaltyData === null ? (
                            <p className="loyalty-small-wrapper-txt">{getStoreCurrencySymbol()} 0</p>
                          ) : (
                            <p className="loyalty-small-wrapper-txt">
                              {getStoreCurrencySymbol()} {loyaltyData?.availablePointValue}
                            </p>
                          )}
                        </div>
                        <h4 className="loyalty-text-main-header">Redeem on this order</h4>
                        <div className="available-wrapper-box-I">
                          <h5 className="points-text-loyalty">Redeemable Points</h5>
                          {loyaltyData === null ? (
                            <p className="loyalty-small-wrapper-txt">0</p>
                          ) : (
                            <p className="loyalty-small-wrapper-txt">
                              {" "}
                              {loyaltyData?.redeemablePoint}
                            </p>
                          )}
                        </div>
                        <div className="available-wrapper-box">
                          <h5 className="points-text-loyalty">Redeemable Value </h5>
                          {loyaltyData === null ? (
                            <p className="loyalty-small-wrapper-txt">{getStoreCurrencySymbol()} 0</p>
                          ) : (
                            <p className="loyalty-small-wrapper-txt">
                              {getStoreCurrencySymbol()}{loyaltyData?.redeemablePointValue}
                            </p>
                          )}
                        </div>
                        <div className="available-wrapper-box">
                          <h5 className="points-text-loyalty">Custom Redeem Value</h5>
                          <BootstrapInput
                            id="bootstrap-input-value"
                            name="value"
                            type="number"
                            value={inputs?.value}
                            className="loyalty-custom-input"
                            onChange={handleInputChange}
                          />
                        </div>
                        <div className="available-wrapper-box">
                          <h5 className="points-text-loyalty">Custom Redeem Points</h5>
                          <BootstrapInput
                            id="bootstrap-input-points"
                            name="points"
                            type="number"
                            value={inputs?.points}
                            className="loyalty-custom-input"
                            onChange={handleInputChange}
                          />
                        </div>
                      </>
                    )}
                    {otpReq ? (
                      <StyledButton
                        style={{ marginTop: "20px" }}
                        autoFocus={!otp ? true : false}
                        fullWidth
                        disabled={!loyaltyData?.redeemable}
                        onClick={handleGetOtp}
                      >
                        Get OTP
                      </StyledButton>
                    ) : (
                      <>
                        <>
                          {blacklisted.stat ? null : (
                            <>
                              {Number(lPoints) > 0 && (lPoints !== null || lPoints != undefined) ? (
                                <StyledButton
                                  fullWidth
                                  onClick={handleremoveloyality}
                                  loading={fetchRedeemPoints?.isLoading || redeemLoader}
                                  autoFocus
                                >
                                  Remove
                                </StyledButton>
                              ) : (
                                <StyledButton
                                  loading={fetchRedeemPoints?.isLoading || redeemLoader}
                                  fullWidth
                                  onClick={handleDirectRedeem}
                                  disabled={fetchRedeemPoints?.isLoading || redeemLoader}
                                >
                                  Redeem
                                </StyledButton>
                              )}
                            </>
                          )}
                        </>
                      </>
                    )}
                  </>
                )}
              </div>
            )}

            {!loyaltyData?.redeemable || !loyaltyData ? (
              <>
                {otp ? (
                  <StyledButton
                    fullWidth
                    disabled={!otpVal}
                    onClick={handleApplyloyality}
                    loading={fetchRedeemPoints?.isLoading || redeemLoader}
                    autoFocus
                  >
                    Redeem
                  </StyledButton>
                ) : null}
              </>
            ) : (
              <>
                {" "}
                {otp ? (
                  Number(lPoints) > 0 && (lPoints !== null || lPoints != undefined) ? (
                    <StyledButton
                      fullWidth
                      onClick={handleremoveloyality}
                      loading={fetchRedeemPoints?.isLoading || redeemLoader}
                      autoFocus
                    >
                      Remove
                    </StyledButton>
                  ) : (
                    <StyledButton
                      fullWidth
                      disabled={!otpVal}
                      onClick={handleApplyloyality}
                      loading={fetchRedeemPoints?.isLoading || redeemLoader}
                      autoFocus
                    >
                      Redeem
                    </StyledButton>
                  )
                ) : null}
              </>
            )}

            <div className="redeem-para-wrapper-box">
              <p
                className={
                  loyaltyData?.redeemable ? "redeem-para-down-green" : "redeem-para-down-red"
                }
              >
                {loyaltyData?.notRedeemableReason}
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div open={noDataFound} className="no-loyalty-wrapper-box">
          {retailType !== "RESTAURANT" && (
            <>
              <div className="circle-bg-image-9"></div>
              <div className="circle-bg-image-10"></div>
            </>
          )}
          <div className="loyalty-content-container">
            <IconButton className="close-loyalty-modal" onClick={closeLoyaltyModal}>
              <CloseIcon />
            </IconButton>
            <h3 className="no-loyalty-text">Let's Get Started: Assign a Customer Number</h3>
            <div className="button-wrapper-center-wrapper">
              <StyledButton onClick={handleLoyaltyCustomer} autoFocus>
                Add Customer
              </StyledButton>
              {/* <Button
              variant="contained"
              onClick={handleLoyaltyCustomer}
              className="add-customer-loyalty"
              ref={AddCusRef}
            >
              <p>Add Customer</p>
            </Button> */}
            </div>
          </div>
        </div>
      )}
    </Box>
  );
};

export default memo(LoyaltySectionModal);
